export const de = {
  // Navbar
  _hello: "_hallo",
  "_about-me": "_über-mich",
  _projects: "_projekte",
  _blog: "_blog",
  _contact: "_kontakt",
  "english-version": "Englische-Version",
  "german-version": "Deutsche-Version",
  "work-reference": "Arbeitszeugnis",

  // Home
  HomeGreeting: "Hallo Welt!",
  HomeName: "Ibrahim",
  HomeSurname: "Adebiyi",
  HomeBio:
    "Ich bin ein leidenschaftlicher Full-Stack JavaScript-Entwickler mit über 5 Jahren Erfahrung im Aufbau moderner, skalierbarer und hochperformanter Webanwendungen. Ich bin spezialisiert auf die Erstellung nahtloser Benutzererlebnisse bei gleichzeitiger Entwicklung effizienter und wartbarer Backend-Systeme. Meine Expertise erstreckt sich über moderne Frontend-Frameworks wie React, Angular, Vue und Next.js, wobei ich mich auf den Aufbau responsiver, intuitiver Schnittstellen mit sauberem und wiederverwendbarem Code konzentriere. Im Backend entwickle ich robuste APIs und skalierbare serverseitige Lösungen mit Node.js, NestJS und Express. Ich arbeite intensiv mit TypeScript und JavaScript und sorge für typsichere, wartbare und qualitativ hochwertige Codebasen. Meine Datenbankerfahrung umfasst sowohl SQL- als auch NoSQL-Datenbanken wie PostgreSQL, MongoDB und Convex.",
  HomeTypewriter: ["FullStack-Entwickler", "Freelancer", "Problemlöser", "KI-Enthusiast"],
  HomeCodeTitle: "hallo.js",
  HomeCodeDev: "entwickler",
  HomeCodeName: "Ibrahim Adebiyi",
  HomeCodeRole: "Full-stack Ingenieur",
  HomeCodeStack: ["Javascript", "Typescript", "Node"],
  HomeCodeAvailable: "true",

  // About Me
  AboutMeTitle: "Über Mich",
  AboutMeSub: "Ein Einblick in meine Reise und berufliche Erfahrung.",
  ExpTitle: "Erfahrung",
  SkillsTitle: "Technische Fähigkeiten",
  CertTitle: "Zertifizierungen",
  AboutMeDesc:
    "Als engagierter Full-Stack-Ingenieur habe ich die letzten 5+ Jahre damit verbracht, die Kunst des Aufbaus skalierbarer und benutzerzentrierter Webanwendungen zu meistern. Meine Reise begann mit der Neugier, wie Dinge im Web funktionieren, und hat sich zu einer Karriere entwickelt, in der ich die Lücke zwischen technischer Komplexität und intuitiven Benutzererlebnissen schließe. Ich blühe in agilen Umgebungen auf und arbeite mit funktionsübergreifenden Teams zusammen, um reale Probleme zu lösen und wirkungsvolle Lösungen zu liefern.",
  AboutMeLong:
    "Ich bin Software-Ingenieur mit über fünf Jahren Berufserfahrung in der Entwicklung und Wartung von produktiven Webanwendungen. Mein Hauptfokus liegt auf der Frontend-Entwicklung mit React, Next, Angular, Vue und TypeScript, aber ich verfüge auch über praktische Backend-Erfahrung in der Arbeit mit Node.js und REST-APIs.\n\nBei der tech11 GmbH trage ich zur Entwicklung einer großen Versicherungsplattform bei, die von Tausenden von Anwendern genutzt wird. Meine Arbeit umfasst den Aufbau wiederverwendbarer UI-Komponenten, die Verbesserung der Frontend-Architektur und die Optimierung der Performance für komplexe Unternehmensanwendungen. Ich arbeite eng mit Produktmanagern, Designern und Backend-Ingenieuren in einem agilen Umfeld zusammen und nehme regelmäßig an Code-Reviews und technischen Diskussionen teil, um eine hohe Codequalität zu gewährleisten.\n\nFrüher in meiner Karriere habe ich an verschiedenen Webplattformen gearbeitet, darunter Unternehmenssysteme, interne Management-Tools und E-Commerce-Anwendungen. Neben der Entwicklung moderner Frontend-Schnittstellen habe ich Backend-Services mit Node.js, Express und MongoDB implementiert und gewartet und verfüge über Erfahrung in der Integration von Frontend-Systemen mit REST-APIs und GraphQL.\n\nIch konzentriere mich auf den Aufbau wartbarer Software, den Entwurf wiederverwendbarer Komponenten und die Lösung realer technischer Probleme in Produktionssystemen. Mein Kern-Stack umfasst Javascript, Typescript, React, Angular, TypeScript, Node.js und moderne Web-Entwicklungstools.",
  SoftwareEngineer: "Software-Ingenieur",
  FrontendFocus: "Software-Ingenieur (Fokus Frontend)",
  FullstackDev: "Frontend / Full-Stack Entwickler",
  FrontendDev: "Frontend Entwickler",
  Fulltime: "Vollzeit",
  Contract: "Freiberuflich",
  Present: "heute",

  // Experience Details
  Exp_Weidmuller:
    "Entwicklung und Erweiterung skalierbarer, hochperformanter Softwaresysteme mit JavaScript/TypeScript mit Fokus auf Webtechnologien und Angular innerhalb eines agilen Teams, Analyse geschäftlicher und technischer Anforderungen, Mitwirkung an Softwarearchitektur und Lösungsdesign sowie Integration moderner Backend-Schnittstellen wie REST-APIs und WebSocket-basierten Diensten unter Verwendung aktueller Frameworks und Best Practices.",
  Exp_Tech11:
    "Entwicklung und Wartung einer groß angelegten Versicherungsplattform, die von Tausenden von Benutzern in mehreren Produktteams genutzt wird. Entwurf und Implementierung wiederverwendbarer UI-Komponenten und gemeinsamer Bibliotheken, die die Konsistenz verbesserten und den doppelten Code um ~30% reduzierten. Mitwirkung an der Migration von Web Components zu Angular mit einer skalierbaren Architektur. Implementierung von Performance-Optimierungen wie Lazy Loading und Code Splitting, wodurch die Ladezeiten um ~25% verbessert wurden. Enge Zusammenarbeit mit Produktmanagern, UX-Designern und Backend-Ingenieuren in einer agilen Umgebung bei gleichzeitiger Teilnahme an Code-Reviews und Pair-Programming zur Sicherstellung einer hohen Codequalität.",
  Exp_Prunedge:
    "Aufbau skalierbarer und responsiver Webanwendungen mit React, Next.js und TypeScript für Unternehmens- und interne Plattformen. Implementierung komplexer Formular-Workflows und modularer Frontend-Architekturen, die die Wartbarkeit und Entwicklungsgeschwindigkeit verbesserten. Entwicklung und Wartung von REST-APIs mit Node.js, Express und MongoDB zur Unterstützung der Frontend-Funktionalität. Erstellung von Frontend-Tests mit der React Testing Library und Förderung von Best Practices durch regelmäßige Code-Reviews. Mentor von 3–5 Junior-Entwicklern und Unterstützung bei der Verbesserung der Teamproduktivität und Codequalität.",
  Exp_FacilityBill:
    "Leitung der Migration einer veralteten monolithischen Laravel-Anwendung auf eine moderne React-basierte Frontend-Architektur. Der Übergang verbesserte die Anwendungsperformance um ca. 30% und ermöglichte eine schnellere Feature-Entwicklung. Implementierung neuer Funktionen, Behebung kritischer Fehler und Verbesserung der Responsivität über verschiedene Geräte hinweg. Direkte Zusammenarbeit mit Stakeholdern und Benutzern, um Anforderungen zu verstehen und das Benutzererlebnis durch moderne Frontend-Praktiken zu verbessern.",
  Exp_Philometer:
    "Entwicklung einer modernen E-Commerce-Plattform für Apotheken mit React und Tailwind CSS. Implementierung wichtiger Funktionen wie Produktsuche, Barcode-basiertes Produktmanagement, Warenkorbfunktionalität und Bestell-Workflows. Integration von Frontend-Komponenten mit Backend-APIs und Zusammenarbeit mit Backend-Entwicklern zur Sicherstellung eines zuverlässigen Datenflusses. Fokus auf die Bereitstellung einer responsiven, benutzerfreundlichen Oberfläche und die Verbesserung der Gesamtperformance der Plattform.",

  // Projects
  ProjectsTitle: "Projekte",
  ProjectsSub: "Eine Auswahl meiner persönlichen und beruflichen Arbeiten.",
  ViewProject: "Projekt ansehen",
  SourceCode: "Quellcode",

  // Contact
  ContactTitle: "Kontaktieren Sie mich",
  ContactSub: "Lassen Sie uns vernetzen und potenzielle Möglichkeiten besprechen.",
  NameLabel: "_name:",
  EmailLabel: "_email:",
  MessageLabel: "_nachricht:",
  SubmitButton: "nachricht-senden",
  ContactSuccess: "Nachricht gesendet! Ich melde mich bald bei Ihnen.",
  ContactFallback: "Noch kein Endpunkt konfiguriert. E-Mail-Programm wird geöffnet.",
  ContactError: "Konnte nicht automatisch gesendet werden. E-Mail-Programm wird geöffnet.",
  BayernGermany: "Bayern, Deutschland",
  FindMeAlsoIn: "finde-mich-auch-auf",
  Contacts: "kontakte",
  SuccessTitle: "Vielen Dank!",
  SuccessText: "Ihre Nachricht wurde gesendet. Ich antworte innerhalb von 24 Stunden!",
  SendNewMessage: "neue-nachricht-senden",
  NamePlaceholder: "Max Mustermann",
  EmailPlaceholder: "max@beispiel.de",
  MessagePlaceholder: "Lass uns gemeinsam etwas aufbauen...",

  // Blog
  BlogPosts: "blog beiträge",
  BlogTitle: "Gedanken &",
  BlogTitleAccent: "Artikel",
  BlogSub: "Lesen Sie aktuelle Ideen und tauschen Sie Kommentare aus.",
  CreateBlogPost: "blog-beitrag-erstellen",
  ExitAdmin: "admin-beenden",
  AdminAccess: "admin-zugang",
  LoadingPosts: "Blog-Beiträge werden geladen...",
  Read: "lesen",
  Edit: "bearbeiten",
  AdminConnected: "Admin verbunden",
  AdminDisconnected: "Admin getrennt",
  EnterAdminKey: "Admin-Schlüssel eingeben",
  PostNotFound: "Beitrag nicht gefunden.",
  BackToBlog: "zurück-zum-blog",
  Back: "zurück",
  EditPost: "beitrag-bearbeiten",
  Comments: "Kommentare",
  AddComment: "kommentar-hinzufügen",
  LoadingComments: "Kommentare werden geladen...",
  NoComments: "Noch keine Kommentare. Schreiben Sie den ersten!",
  YourName: "Ihr Name",
  WriteComment: "Schreiben Sie einen Kommentar...",
  CommentAdded: "Kommentar hinzugefügt.",
  EnterComment: "Bitte geben Sie einen Kommentar ein.",
  Anonymous: "Anonym",
  LoadingPost: "Beitrag wird geladen...",
  AdminRequired: "Admin-Zugang ist erforderlich, um Beiträge zu erstellen/bearbeiten.",
  UnlockAdmin: "admin-entsperren",
  AdminKeyRequired: "Admin-Schlüssel ist erforderlich.",
  FillRequiredFields: "Bitte Titel, Auszug und Inhalt ausfüllen.",
  PostCreated: "Blog-Beitrag erfolgreich erstellt.",
  PostUpdated: "Blog-Beitrag erfolgreich aktualisiert.",
  ValidImage: "Bitte laden Sie eine gültige Bilddatei hoch.",
  SavePost: "beitrag-speichern",
  UpdatePost: "beitrag-aktualisieren",
  DeletePost: "beitrag-löschen",
  DeleteConfirm: "Diesen Beitrag dauerhaft löschen?",
  PostDeleted: "Beitrag gelöscht.",
  EditBlogPost: "Blog-Beitrag bearbeiten",
  BlogNotConfigured: "Blog-Backend ist noch nicht konfiguriert.",
  BlogHint: "Fügen Sie REACT_APP_CONVEX_URL zu Ihrer .env hinzu und führen Sie Convex aus.",

  // Footer
  MadeWith: "Erstellt mit",
  By: "von",
  FooterCredits: "Erstellt mit React & Convex",
  FindMeOn: "finde mich auf:",

  // Common
  Loading: "Laden...",
  Error: "Ein Fehler ist aufgetreten.",

  // Personal Info Labels
  PersonalInfo: "persönliche-infos",
  Interests: "// interessen",
  SkillsTab: "_fähigkeiten",
  ExperienceTab: "_erfahrung",
  CertsTab: "_zertifikate",

  // Interests
  Interest_WebDev: "Webentwicklung",
  Interest_OpenSource: "Open Source",
  Interest_Web3: "Web3 / Blockchain",
  Interest_Prompting: "Prompting",
  Interest_AI: "KI",
  Interest_Football: "Fußball",

  // Dates
  Mon: "Mo",
  Tue: "Di",
  Wed: "Mi",
  Thu: "Do",
  Fri: "Fr",
  Sat: "Sa",
  Sun: "So",
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mär",
  Apr: "Apr",
  May: "Mai",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dez",

  // Project descriptions
  Proj_LMS_Name: "Lernmanagement-Lösung",
  Proj_LMS_Desc: "Lernmanagement-Lösung für den Bundesstaat Delta, Nigeria",
  Proj_MIPAD_Name: "MIPAD",
  Proj_MIPAD_Desc: "Plattform zur Veranstaltungsregistrierung und -verfolgung für MIPAD",
  Proj_Estate_Name: "Immobilienverwaltungs-Lösung",
  Proj_Estate_Desc: "Lösung zur Verwaltung von Immobilien",
  Proj_Loan_Name: "Kredit-App",
  Proj_Loan_Desc: "Kredit-App für die Stanbic IBTC",
  Proj_Citizen_Name: "Bürgerverwaltung",
  Proj_Citizen_Desc: "Bürgerverwaltung für den Bundesstaat OYO",
  Proj_RMS_Name: "RMS",
  Proj_RMS_Desc: "Fernüberwachungssystem (Starsight)",
  Proj_Proworks_Name: "Proworks",
  Proj_Proworks_Desc: "System zur Automatisierung von Geschäftsprozessen für den Bundesstaat OYO",
  Proj_PollEasy_Name: "PollEasy",
  Proj_PollEasy_Desc:
    "Eine Plattform, die hilft, Daten zu sammeln und Analysen zu erstellen, um Wahlen zu verwalten.",
  Proj_Tech11_Name: "Tech11 Versicherung",
  Proj_Tech11_Desc:
    "Die T11 Versicherungsplattform wird für das Versicherungsmanagement verwendet, geschrieben in Web Components",
  Proj_NPI_Name: "Nigeria Poverty Index (NPI)",
  Proj_NPI_Desc:
    "Analyse der multidimensionalen Armut in Nigeria, einschließlich ihrer Zusammensetzung und Aufschlüsselung nach Bundesstaaten und Distrikten",
  Proj_HRMS_Name: "HR Management System API",
  Proj_HRMS_Desc:
    "Backend-API für ein Personalverwaltungssystem zur Unterstützung von Mitarbeiterdatensätzen, Urlaubsmanagement, Authentifizierung und Gehaltsabrechnungs-Workflows. Aufbau skalierbarer REST-APIs und Handhabung von Datenpersistenz und rollenbasierter Zugriffskontrolle.",
  Proj_LMS_BE_Name: "Lernmanagement-System Backend",
  Proj_LMS_BE_Desc:
    "Backend-Service für eine LMS-Plattform zur Verwaltung von Kursen, Verfolgung des Studentenfortschritts, Authentifizierung und Inhaltsbereitstellung. Entwurf von REST-APIs und Integration von Frontend-Anwendungen in eine skalierbare Backend-Architektur.",
  Proj_Ecom_BE_Name: "E-Commerce-Plattform API",
  Proj_Ecom_BE_Desc:
    "Backend-Dienste zur Unterstützung einer Pharma-E-Commerce-Plattform, einschließlich Produktkatalogverwaltung, Warenkorboperationen, Bestellabwicklung und API-Integration mit Frontend-Systemen.",
};
